// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__LjmMl","left":"StickyBox_left__3KQ5y","right":"StickyBox_right__1otl0"};